///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import tlColumnConstants from "./tlColumnConstants";

export const euColumnConstants = {
  ...tlColumnConstants,
  RATE_PER_UNIT: "ratePerKilometer",
  BASE_RATE_PER_UNIT: "baseRatePerKilometer",
  ORIGIN_PLACE: "originPlaceName",
  ORIGIN_COUNTRY: "originCountryCode",
  DESTINATION_PLACE: "destinationPlaceName",
  DESTINATION_COUNTRY: "destinationCountryCode",
  SHIPPER_DISTANCE: "shipperDistance",
  COYOTE_DISTANCE: "coyoteDistance",
  COST_PER_UNIT: "costPerKilometer",
  DROP_TRAILER: "dropTrailer",
  SHIPPER_TRANSIT_TIME: "shipperTransitTime",
  DOUBLE_MAN: "doubleMan",
  ADR: "adr",
  PALLET_EXCHANGE: "palletExchange",
  NUMBER_OF_ADDITIONAL_STOPS: "numberOfAdditionalStops",
  ROUND_TRIP: "roundTrip",
  OPERATIONS_SURCHARGE_AMOUNT: "operationsSurchargeAmount",
  IMPORT_LANE_ID: "importLaneId",
  ORIGIN_CLUSTER_NAME: "originClusterName",
  DESTINATION_CLUSTER_NAME: "destinationClusterName",
  NDI: "ndi"
};

export default euColumnConstants;
